import PropTypes from 'prop-types';
import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    const savedToken = localStorage.getItem('token');

    if (savedUser && savedUser !== 'undefined' && savedToken) {
      try {
        setUser(JSON.parse(savedUser));
        setToken(savedToken);
      } catch (e) {
        console.error('Failed to parse saved user:', e);
        localStorage.removeItem('user');
      }
    }

    setLoading(false);
  }, []);

  const setAndStoreUser = (newUser) => {
    if (Array.isArray(newUser?.consentImages)) {
      newUser.consentImages = newUser.consentImages
        .map((image) => (image?.url ? image.url : image))
        .filter(Boolean);
    }

    setUser(newUser);
    localStorage.setItem('user', JSON.stringify(newUser));
  };

  const login = (userData, token) => {
    setUser(userData);
    setToken(token);
    console.log(userData);
    console.log(token);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', token);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser: setAndStoreUser, token, login, logout, loading }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export const useAuth = () => useContext(AuthContext);
